module.exports = __webpack_public_path__ + "286da67aa3cd3c7912c96e4b4e264185.svg";